import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import moment from 'moment';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { CrosselingItem } from '../../../../model/Crosseling/CrosselingItem';
import { HttpResponse } from '../../../../model/HttpResponse';
import { QueryOptionDto } from '../../../../model/QueryOptionDto';
import { AcademyAdministratorOperation } from '../../../../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../../../../model/administrator/AcademyAdministratorType';
import { AdministratorEntity } from '../../../../model/administrator/AdministratorEntity';
import { Category } from '../../../../model/competitions/Category';
import { Competition } from '../../../../model/competitions/Competition';
import { CategoryLevel } from '../../../../model/competitions/Level';
import { Registration } from '../../../../model/competitions/Registration';
import { CompetitionType } from '../../../../model/competitions/competitionType';
import { RegistrationStatus } from '../../../../model/enum/RegistrationStatus';
import { RegistrationType } from '../../../../model/enum/RegistrationType';
import { SkateType } from '../../../../model/enum/SkateType';
import { Member } from '../../../../model/member';
import { Modalidad } from '../../../../model/Modalidad';
import { GestionService } from '../../../../services/gestion.service';
import { LoadingService } from '../../../../services/loading.service';
import {
  ExcelReport,
  ReportService,
} from '../../../../services/report.service';
import { CompetitionFormComponent } from '../../competition-form/competition-form.component';
import { CompetitionDetailComponent } from '../competition-detail.component';
interface ExportColumn {
  title: string;
  dataKey: string;
}
@Component({
  selector: 'app-registrations-table',
  standalone: true,
  imports: [
    ChipModule,
    TableModule,
    DialogModule,
    RippleModule,
    ButtonModule,
    ToastModule,
    ToolbarModule,
    ConfirmDialogModule,
    InputTextModule,
    InputTextareaModule,
    CommonModule,
    FileUploadModule,
    DropdownModule,
    TagModule,
    RadioButtonModule,
    RatingModule,
    InputTextModule,
    FormsModule,
    InputNumberModule,
    TooltipModule,
    CompetitionFormComponent,
    CompetitionDetailComponent,
  ],
  templateUrl: './registrations-table.component.html',
  styleUrl: './registrations-table.component.scss',
})
export class RegistrationsTableComponent implements OnInit {
  @Input()
  competition!: Competition;

  @Input()
  registrations: Registration[] = [];

  @Input()
  categories: Category[] = [];

  @Input()
  levels: CategoryLevel[] = [];

  showRegistrations = false;
  registrarionSelected!: Registration;

  members: Member[] = [];

  showTableRegisters: boolean = false;
  constructor(
    private gestionService: GestionService,
    private reportService: ReportService,
    private loadingService: LoadingService
  ) {}
  ngOnInit(): void {
    this.getDataOfRegistrations();
  }

  async getDataOfRegistrations(): Promise<void> {
    const membersId = this.registrations
      .filter(
        (registration) =>
          registration.registrationType === RegistrationType.MEMBER_REGISTRATION
      )
      .map((reg) => reg.memberId) as string[];
    if (membersId.length > 0) {
      this.getMembersByIds(membersId);
    } else {
      this.showTableRegisters = true;
    }
  }

  getMembersByIds(ids: string[]) {
    this.loadingService.showLoading();
    const conditionals = ids.map((id, i) => {
      const option = {
        conditionalConnector: 'OR',
        logicOperator: '=',
        evaluatedProperty: 'id',
        parameterName: `@MemberId${i}`,
        parameterValue: id,
      };
      return option;
    });

    const options: QueryOptionDto = {
      options: {
        conditionals: conditionals,
      },
    };

    try {
      const entity: AdministratorEntity = {
        operation: AcademyAdministratorOperation.SELECT,
        type: AcademyAdministratorType.MEMBERS_MASSIVE,
        payload: options,
      };

      this.gestionService.sendRequest(entity).subscribe((res: HttpResponse) => {
        if (res.code === 200) {
          this.members = res.response as Member[];
          this.showTableRegisters = true;
        }
        this.loadingService.hideLoading();
      });
    } catch (error) {
      this.loadingService.hideLoading();
      throw Error(`Ocurrió un error obteniendo las solicitudes: ${error}`);
    }
  }

  getRegistredMemberById(memberId: string): Promise<Member> {
    return new Promise((resolve, reject) => {
      try {
        const entity: AdministratorEntity = {
          operation: AcademyAdministratorOperation.FIND,
          type: AcademyAdministratorType.MEMBERS_MASSIVE,
          payload: { id: memberId },
        };

        this.gestionService
          .sendRequest(entity)
          .subscribe((res: HttpResponse) => {
            if (res.code === 200) {
              resolve(res.response as Member);
            }
          });
      } catch (error) {
        reject(
          new Error(`Ocurrió un error obteniendo las solicitudes: ${error}`)
        );
      }
    });
  }

  getCompetitionAge(birthDay: string) {
    return moment(this.competition.baseDateToCalculateAge).diff(
      birthDay,
      'years'
    );
  }

  getCategory(member: Member) {
    const age = this.getCompetitionAge(member.birthDay);
    const level = this.levels.find(
      (level: CategoryLevel) => level.name === member.nivel
    );
    return this.categories.find(
      (category: Category) =>
        category.minYearsOld <= age &&
        category.maxYearsOld >= age &&
        category.idCategoryLevel === level?.id
    );
  }

  exportGeneralReport() {
    if (this.competition.modality === Modalidad.ARTISTICO) {
      this.exportArtisticoReport();
    } else {
      this.exportStandardReport();
    }
  }

  exportArtisticoReport() {
    const reports: ExcelReport[] = [];
    
    // Si la competición tiene eventos, crear reporte por eventos
    if (this.competition.events && this.competition.events.length > 0) {
      this.competition.events.forEach((event) => {
        const membersInEvent = this.getMembersByEvent(event.id!);
        if (membersInEvent.length > 0) {
          const dataToPrint = membersInEvent.map((member: Member) => {
            const memberCategory = this.getMemberCategoryForEvent(member.id!, event.id!);
            const memberLevel = this.getMemberLevelForEvent(member.id!, event.id!);
            const registration = this.getDataOfRegistrationByMemberId(member.id!);
            
            let reportEntity: any = {
              club: member.club.name,
              identificacion: `${member.idType}${member.idNumber}`,
              nombres: member.name.toUpperCase(),
              apellidos: member.lastName.toUpperCase(),
              'fecha de nacimiento': member.birthDay,
              'edad competencia': this.getCompetitionAge(member.birthDay),
              nivel: memberLevel,
              categoria: memberCategory,
              rama: member.gender === 'M' ? 'MASCULINO' : 'FEMENINO',
              evento: event.name,
            };

            if (
              this.competition.type === CompetitionType.EXTERNAL ||
              this.competition.type === CompetitionType.MEMBERS_AND_EXTERNAL
            ) {
              reportEntity['Tipo Patín'] =
                member?.customType?.skateType || SkateType.NA;
            }

            if (this.competition.hasCrosselling) {
              reportEntity['Items Asociados'] = registration
                ?.customData?.crosselingItems
                ?.filter((item: CrosselingItem) => item.isIncluded)
                .map((item: any) => `${item.name} ($${item.amount.toLocaleString()})`)
                .join(', ') ?? 'N/A';
            }

            reportEntity['Estado Inscripción'] =
              registration?.status === RegistrationStatus.REGISTERED
                ? 'Inscrito'
                : 'Pre Inscrito';

            return reportEntity;
          });

          const sheetName = `${event.name}`.replace(/[\\\/\?\*\[\]]/g, '_');
          reports.push({
            data: dataToPrint,
            sheetName: sheetName.length > 31 ? sheetName.substring(0, 31) : sheetName,
          });
        }
      });
    }

    // Si no se generaron reportes por eventos, crear reporte por categorías
    if (reports.length === 0) {
      this.generateReportsByCategory(reports);
    }

    const reportName = `Reporte ARTÍSTICO por Eventos ${
      this.competition.name
    } ${moment().format('DD-MM-YYYY')}`;
    
    this.reportService.exportExcel(reports, reportName);
  }

  exportStandardReport() {
    const dataToPrint = this.members.map((member: Member) => {
      const category = this.getCategory(member);
      const level = this.levels.find(
        (level: CategoryLevel) => level.id === category?.idCategoryLevel
      );
      let reportEntity: any = {
        club: member.club.name,
        identificacion: `${member.idType}${member.idNumber}`,
        nombres: member.name.toUpperCase(),
        apellidos: member.lastName.toUpperCase(),
        'fecha de nacimiento': member.birthDay,
        'edad competencia': this.getCompetitionAge(member.birthDay),
        nivel: level?.name,
        categoria: category?.name,
        rama: member.gender === 'M' ? 'MASCULINO' : 'FEMENINO',
      };
      if (
        this.competition.type === CompetitionType.EXTERNAL ||
        this.competition.type === CompetitionType.MEMBERS_AND_EXTERNAL
      ) {
        reportEntity['Tipo Patín'] =
          member?.customType?.skateType || SkateType.NA;
      }

      if (this.competition.hasCrosselling) {
        reportEntity['Items Asociados'] = this.getDataOfRegistrationByMemberId(
          member.id!
        )
          ?.customData?.crosselingItems
          ?.filter((item: CrosselingItem) => item.isIncluded)
          .map((item: any) => `${item.name} ($${item.amount.toLocaleString()})`)
          .join(', ') ?? 'N/A';
      }

      reportEntity['Estado Inscripción'] =
        this.getDataOfRegistrationByMemberId(member.id!)?.status ===
        RegistrationStatus.REGISTERED
          ? 'Inscrito'
          : 'Pre Inscrito';

      return reportEntity;
    });
    const reportName = `Reporte General de inscritos ${
      this.competition.name
    } ${moment().format('DD-MM-YYYY')}`;
    const excelReport: ExcelReport = {
      data: dataToPrint,
      sheetName: 'General',
    };
    this.reportService.exportExcel([excelReport], reportName);
  }

  getDataOfRegistrationByMemberId(memberId: string) {
    return this.registrations.find(
      (registration) => registration.memberId === memberId
    );
  }

  getCrossSellingDescription(memberId: string): string {
    const registration = this.getDataOfRegistrationByMemberId(memberId);
    if (!registration?.customData?.crosselingItems) return '';
    return registration.customData.crosselingItems
        .filter((item: any) => item.isIncluded)
        .map((item: any) => `${item.name} ($${item.amount.toLocaleString()})`)
        .join(', ');
  }

  getSelectedEventsByMemberId(memberId: string): string[] {
    const registration = this.getDataOfRegistrationByMemberId(memberId);
    
    // Usar la nueva estructura de customData.extraInfo.events
    if (registration?.customData && 
        (registration.customData as any).extraInfo && 
        (registration.customData as any).extraInfo.events) {
      const events = (registration.customData as any).extraInfo.events;
      return events.map((eventInfo: any) => 
        eventInfo.event ? eventInfo.event.name : 'Evento sin nombre'
      );
    }
    
    // Si la competición tiene eventos, mostrar todos como seleccionados por defecto
    if (this.competition.events && this.competition.events.length > 0) {
      return this.competition.events.map(event => event.name);
    }
    
    return [];
  }

  getGeneralArtisticoData(): any[] {
    return this.members.map((member: Member) => {
      const category = this.getCategory(member);
      const level = this.levels.find(
        (level: CategoryLevel) => level.id === category?.idCategoryLevel
      );
      const registration = this.getDataOfRegistrationByMemberId(member.id!);
      
      let reportEntity: any = {
        club: member.club.name,
        identificacion: `${member.idType}${member.idNumber}`,
        nombres: member.name.toUpperCase(),
        apellidos: member.lastName.toUpperCase(),
        'fecha de nacimiento': member.birthDay,
        'edad competencia': this.getCompetitionAge(member.birthDay),
        nivel: level?.name,
        categoria: category?.name,
        rama: member.gender === 'M' ? 'MASCULINO' : 'FEMENINO',
      };

      // Agregar información de eventos para modalidad ARTÍSTICO
      if (this.competition.events && this.competition.events.length > 0) {
        const selectedEvents = this.getSelectedEventsByMemberId(member.id!);
        reportEntity['Eventos'] = selectedEvents.length > 0 
          ? selectedEvents.join(', ') 
          : 'No especificado';
      }

      if (
        this.competition.type === CompetitionType.EXTERNAL ||
        this.competition.type === CompetitionType.MEMBERS_AND_EXTERNAL
      ) {
        reportEntity['Tipo Patín'] =
          member?.customType?.skateType || SkateType.NA;
      }

      if (this.competition.hasCrosselling) {
        reportEntity['Items Asociados'] = registration
          ?.customData?.crosselingItems
          ?.filter((item: CrosselingItem) => item.isIncluded)
          .map((item: any) => `${item.name} ($${item.amount.toLocaleString()})`)
          .join(', ') ?? 'N/A';
      }

      reportEntity['Estado Inscripción'] =
        registration?.status === RegistrationStatus.REGISTERED
          ? 'Inscrito'
          : 'Pre Inscrito';

      return reportEntity;
    });
  }

  // Métodos para obtener miembros por evento específico
  getMembersByEvent(eventId: string): Member[] {
    return this.members.filter(member => {
      const registration = this.getDataOfRegistrationByMemberId(member.id!);
      
      // Verificar si el miembro está inscrito en este evento específico usando la estructura real
      if (registration?.customData && 
          (registration.customData as any).extraInfo && 
          (registration.customData as any).extraInfo.events) {
        const events = (registration.customData as any).extraInfo.events;
        return events.some((eventInfo: any) => 
          eventInfo.event && eventInfo.event.id === eventId
        );
      }
      
      // Si no hay información específica de eventos, incluir a todos los miembros
      return true;
    });
  }

  // Obtener la categoría específica en la que participa un miembro para un evento
  getMemberCategoryForEvent(memberId: string, eventId: string): string {
    const registration = this.getDataOfRegistrationByMemberId(memberId);
    
    // Buscar la categoría en la estructura real de customData
    if (registration?.customData && 
        (registration.customData as any).extraInfo && 
        (registration.customData as any).extraInfo.events) {
      const events = (registration.customData as any).extraInfo.events;
      const eventInfo = events.find((e: any) => 
        e.event && e.event.id === eventId
      );
      if (eventInfo && eventInfo.category) {
        return eventInfo.category.name || 'No especificada';
      }
    }
    
    // Usar la categoría general del miembro como respaldo
    const member = this.members.find(m => m.id === memberId);
    if (member) {
      const category = this.getCategory(member);
      return category?.name || 'No especificada';
    }
    
    return 'No especificada';
  }

  // Obtener el nivel específico en el que participa un miembro para un evento
  getMemberLevelForEvent(memberId: string, eventId: string): string {
    const registration = this.getDataOfRegistrationByMemberId(memberId);
    
    // Buscar el nivel (sublevel) en la estructura real de customData
    if (registration?.customData && 
        (registration.customData as any).extraInfo && 
        (registration.customData as any).extraInfo.events) {
      const events = (registration.customData as any).extraInfo.events;
      const eventInfo = events.find((e: any) => 
        e.event && e.event.id === eventId
      );
      if (eventInfo && eventInfo.sublevel) {
        return eventInfo.sublevel.name || 'No especificado';
      }
    }
    
    // Usar el nivel general del miembro como respaldo
    const member = this.members.find(m => m.id === memberId);
    if (member) {
      const category = this.getCategory(member);
      if (category) {
        const level = this.levels.find(
          (level: CategoryLevel) => level.id === category.idCategoryLevel
        );
        return level?.name || 'No especificado';
      }
    }
    
    return 'No especificado';
  }

  // Método para generar reportes por categorías (fallback)
  generateReportsByCategory(reports: ExcelReport[]): void {
    const membersByCategory = new Map<string, Member[]>();
    
    this.members.forEach((member: Member) => {
      const category = this.getCategory(member);
      if (category) {
        const key = `${category.name}`;
        if (!membersByCategory.has(key)) {
          membersByCategory.set(key, []);
        }
        membersByCategory.get(key)!.push(member);
      }
    });

    // Crear un reporte para cada categoría
    membersByCategory.forEach((members, categoryName) => {
      const dataToPrint = members.map((member: Member) => {
        const category = this.getCategory(member);
        const level = this.levels.find(
          (level: CategoryLevel) => level.id === category?.idCategoryLevel
        );
        const registration = this.getDataOfRegistrationByMemberId(member.id!);
        
        let reportEntity: any = {
          club: member.club.name,
          identificacion: `${member.idType}${member.idNumber}`,
          nombres: member.name.toUpperCase(),
          apellidos: member.lastName.toUpperCase(),
          'fecha de nacimiento': member.birthDay,
          'edad competencia': this.getCompetitionAge(member.birthDay),
          nivel: level?.name,
          categoria: category?.name,
          rama: member.gender === 'M' ? 'MASCULINO' : 'FEMENINO',
        };

        // Agregar información de eventos
        if (this.competition.events && this.competition.events.length > 0) {
          const selectedEvents = this.getSelectedEventsByMemberId(member.id!);
          reportEntity['Eventos'] = selectedEvents.length > 0 
            ? selectedEvents.join(', ') 
            : 'Todos los eventos';
        }

        if (
          this.competition.type === CompetitionType.EXTERNAL ||
          this.competition.type === CompetitionType.MEMBERS_AND_EXTERNAL
        ) {
          reportEntity['Tipo Patín'] =
            member?.customType?.skateType || SkateType.NA;
        }

        if (this.competition.hasCrosselling) {
          reportEntity['Items Asociados'] = registration
            ?.customData?.crosselingItems
            ?.filter((item: CrosselingItem) => item.isIncluded)
            .map((item: any) => `${item.name} ($${item.amount.toLocaleString()})`)
            .join(', ') ?? 'N/A';
        }

        reportEntity['Estado Inscripción'] =
          registration?.status === RegistrationStatus.REGISTERED
            ? 'Inscrito'
            : 'Pre Inscrito';

        return reportEntity;
      });

      const sheetName = `${categoryName}`.replace(/[\\\/\?\*\[\]]/g, '_');
      reports.push({
        data: dataToPrint,
        sheetName: sheetName.length > 31 ? sheetName.substring(0, 31) : sheetName,
      });
    });

    // Si no hay categorías, crear reporte general
    if (reports.length === 0) {
      reports.push({
        data: this.getGeneralArtisticoData(),
        sheetName: 'General',
      });
    }
  }
}
